import { Component, Input } from "@angular/core";
import { EventCardComponent } from "@shared/components/cards/event-card/event-card.component";
import { SkeletonModule } from "primeng/skeleton";
import { EventInfoResponseBody } from "../../../services/types/events-management-response.type";

@Component({
  selector: "app-followed-producers-events",
  imports: [EventCardComponent, SkeletonModule],
  templateUrl: "./followed-producers-events.component.html",
  styleUrl: "./followed-producers-events.component.scss",
})
export class FollowedProducersEventsComponent {
  @Input() events: EventInfoResponseBody[] | null = null;
}
